import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { StatusComponent } from '../../../component/status.component';
import { FilterClearButtonComponent } from '../filter-clear-button.component';
import { MatFormField, MatLabel } from '@angular/material/input';
import { MatOption, MatSelect, MatSelectTrigger } from '@angular/material/select';
import { MatSuffix } from '@angular/material/form-field';
import { AbstractFilterComponent } from './abstract-filter.component';
import { StatusCodes } from '../../../model/status';
@Component({
  selector: 'cappus-filter-status-codes',
  imports: [
    MatFormField,
    MatLabel,
    MatSelect,
    ReactiveFormsModule,
    MatOption,
    StatusComponent,
    MatSelectTrigger,
    FilterClearButtonComponent,
    MatSuffix,
  ],
  templateUrl: './filter-status-codes.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterStatusCodesComponent<STATUS> extends AbstractFilterComponent<STATUS> {
  protected readonly StatusCodes = StatusCodes;
}
